import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom'
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBInput,
  MDBContainer,
  MDBRow,
  MDBValidation,
  MDBValidationItem,
  MDBCardTitle,
  MDBCardText,
  MDBCheckbox


}
from 'mdb-react-ui-kit';
import '../../../css/index.css';



function EditarRelacionamentoResponsavel() {
  const navigate = useNavigate();
  const [usuario, setUsuario] = useState([]);
  const util = require('../../../utils/index');
  const userLogin = util.getUser();
  const api = require('../../../apis/relacionamento-responsavel')
  const {idresponsavel, ra} = useParams();
  console.log(idresponsavel, ra)

  const [formValue, setFormValue] = useState({
    nomeResponsavel: "",
    nomeAluno: "",
    idResponsavel: "",
    aluno: "",
    idFilial: "",
    idEscola: "",
  });

  const [checked, setChecked] = useState(false);


  const handleDelet = async () => {
    console.log(formValue)
    const object = {
        id: formValue.id
    }
    util.isSubmitting()
    const result = await api.excluirResponsavelApi(object);
    result ? toast.success("Excluido com sucesso!") && navigate("/area-relacionamento-responsavel") : null;
    util.isSubmitting()
    
  }

  useEffect(() => {
    const getRelacionamento = async () => {
      try {
        const object = {
          cpf: idresponsavel,
          idEscola: userLogin.idescola,
          idFilial: userLogin.idfilial,
          RA: ra

        };
        const response = await api.pegarResponsavelApiRA(object);
        const data = await response;
        
        setUsuario(data[0]);
        setFormValue({
          id: data[0].id,
          nomeResponsavel: data[0].nome_responsavel,
          idResponsavel: data[0].id,
          idFilial: userLogin.idfilial,
          idEscola: userLogin.idescola,
          nomeAluno: data[0].nome_aluno,
          aluno: data[0].ra,

        });
      } catch (error) {
        console.error('Erro ao obter dados:', error);
      }
    };

    getRelacionamento();
  }, [idresponsavel]);



  return (
    <MDBContainer fluid className=' background-radial-gradient' style={{
       minHeight:'500',display:"flex", justifyContent:"center", alignItems:"center"
      
      }}>
      <MDBRow center className='w-100 d-flex flex-column my-5 align-items-center'>

          <MDBCard className='bg-dark text-white w-50' style={{borderRadius: '1rem', minWidth: '300px'}}>
              <MDBCardBody className='d-flex flex-column align-items-center'>

              <MDBCardTitle className='text-white my-5'>Bem vindo, {util.decideName(userLogin)}</MDBCardTitle>
                  <MDBValidation className='w-100' onSubmit={handleDelet}>
                  <div className='d-flex justify-content-between'>
                    <MDBValidationItem style={{width:'40%', opacity:0.4}} feedback='Por favor digite o nome do responsavel!' invalid>
                        <MDBInput 
                          wrapperClass='mb-1 w-100' 
                          className='bg-dark'
                          labelClass='text-white' 
                          label='Nome do responsavel' id='formControNomeResponsavel' 
                          type='text' 
                          size="lg" 
                          style={{color:"white"}}
                          name='nomeResponsavel'
                          value={formValue.nomeResponsavel || ''}
                          required
                          minLength={3}
                          disabled={true}
                          />
                        
                      </MDBValidationItem>
                      <MDBValidationItem style={{width:'40%', opacity:0.4}} feedback='Por favor digite o CPF!' invalid>
                        <MDBInput 
                          className='bg-dark'
                          wrapperClass='mb-5 w-100' 
                          labelClass='text-white' 
                          label='CPF' id='formControCPF' 
                          disabled={true}
                          type='text' 
                          size="lg" 
                          style={{color:"white"}}
                          name='cpf'
                          value={idresponsavel || ''}
              
                          
                          required
                          minLength={3}
                          
                          />
                        
                      </MDBValidationItem>
                      
    
                      </div>
                      <div className='d-flex justify-content-between'>
                    <MDBValidationItem style={{width:'40%', opacity:0.4}} feedback='Por favor digite o nome do aluno!' invalid>
                        <MDBInput 
                          wrapperClass='mb-1 w-100' 
                          className='bg-dark'
                          labelClass='text-white' 
                          label='Nome do aluno' id='formControNomeAluno' 
                          type='text' 
                          size="lg" 
                          style={{color:"white"}}
                          name='nomeAluno'
                          value={formValue.nomeAluno || ''}                       
                          required
                          minLength={3}
                          disabled={true}
                          />
                
                      </MDBValidationItem>
                      <MDBValidationItem style={{width:'40%', opacity:0.4}} feedback='Por favor digite o RA!' invalid>
                        <MDBInput 
                          className='bg-dark'
                          wrapperClass='mb-1 w-100' 
                          labelClass='text-white' 
                          label='RA' id='formControRA' 
                          type='text' 
                          size="lg" 
                          style={{color:"white"}}
                          name='ra'
                          value={ra || ''}
                          
                          
                          required
                          disabled={true}
                          minLength={3}
                          
                          />
                        
                      </MDBValidationItem>
                      
    
                      </div>
                    
                    
                    <div className='my-2'>
                        <MDBCheckbox

                            id='controlledCheckbox'
                            label='Habilitar botão "Exluir"'
                            checked={checked}
                            onChange={() => setChecked(!checked)}
                        />
                    </div>
                    <div className='d-flex justify-content-between align-items-center flex-column'>
                        <MDBBtn 
                            outline 
                            className='my-3 btn-home w-100' 
                            color='white' 
                            size='lg'
                            type='submit'   
                            id='submitForm'  
                            disabled={!checked}                 
                            >
                            
                            excluir
                        </MDBBtn>
                      </div>
                      <MDBBtn 
                        outline 
                        className='px-5 w-100 mt-4 btn-home' 
                        color='white' 
                        size='sm'
                        type='submit'   
                        onClick={() => {
                          navigate("/listar-relacionamento-responsavel")
                        }}
                        >
                        
                        Voltar
                      </MDBBtn>
                  </MDBValidation>
              </MDBCardBody>
          </MDBCard>
      </MDBRow>

    </MDBContainer>
  );
}

export default EditarRelacionamentoResponsavel;